import { useAppHeaderObserver } from 'hooks/useAppLayoutObservers'
import React, { useRef } from 'react'
import NavBarGlobalBar from './NavBarGlobalBar'
import NavBarTertiaryBar from './NavBarTertiaryBar'
import NavBarUtilBar from './NavBarUtilBar'
import styled from 'styled-components'
import Breakpoint from 'components/Common/Breakpoint'
import NavBarSearchDrawer from './NavBarSearch/NavBarSearchDrawer'

const NavBarContainer = styled.div`
  position: relative;
`

function NavBar() {
  const ref = useRef<HTMLDivElement>(null)
  useAppHeaderObserver(ref)

  return <>
    <NavBarContainer ref={ref}>
      <NavBarTertiaryBar />
      <NavBarUtilBar />
      <NavBarGlobalBar />
    </NavBarContainer>
    <Breakpoint max="mobile">
      <NavBarSearchDrawer />
    </Breakpoint>
  </>
}

export default React.memo(NavBar)
